import styled from 'styled-components'

interface TableTagProps {
  bgColor?: string
  background?: string
  color: string
  borderRadius?: number
  style?: React.CSSProperties
}
export const Tags = styled.div<TableTagProps>`
  display: inline-block;
  border-radius: ${props => props.borderRadius || 4}px;
  padding: 4px 6px;
  font-size: 12px;
  line-height: 14px !important;
  font-weight: 400;
  color: ${props => props.color};
  background: ${props => props.background};
  border: ${props => (props.bgColor ? `1px solid ${props.bgColor}` : '')};
  cursor: pointer;
`
